import { useFormikContext } from "formik";
import React, { FC } from "react";
import InformationDrawer from "../../Unknown/InformationDrawer";
import PatientMainCards, { PatientMainCardsProps } from "../PatientMainCards";
import useInformationDrawerActionButtons from "./useInformationDrawerActionButtons";

export type PatientInformationDrawerProps = {
  isOpen: boolean;
  handleClose: () => void;
  isEditMode: boolean;
  handleEditModeChange: (value: boolean) => void;
  canMerge?: boolean;
  onMergeClick?: () => void;
} & PatientMainCardsProps;

const PatientInformationDrawer: FC<PatientInformationDrawerProps> = ({
  isOpen,
  handleClose,
  isEditMode,
  handleEditModeChange,
  isLoading,
  error,
  data,
  canMerge,
  onMergeClick,
}) => {
  const { isSubmitting, handleSubmit, resetForm } = useFormikContext();

  const informationDrawerActionButtons = useInformationDrawerActionButtons({
    isEditMode,
    handleEditModeChange,
    // 'failed' stays usable (auto-clears on retry) — only 'pending' disables EDIT/MERGE.
    isButtonsDisabled:
      isSubmitting || !!isLoading || data?.mergeStatus === "pending",
    handleSubmit,
    resetForm,
    canMerge,
    onMergeClick,
  });

  return (
    <InformationDrawer
      isOpen={isOpen}
      handleClose={handleClose}
      actionButtons={informationDrawerActionButtons}
    >
      <PatientMainCards
        isEditMode={isEditMode}
        isLoading={isLoading}
        error={error}
        data={data}
      />
    </InformationDrawer>
  );
};

export default PatientInformationDrawer;
